const inicialState = {
  congelacaoFinalizada: false, 
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/congelacao/congelacao.state.js